export default "__VITE_ASSET__D2jgW5AC__"